import { CatalogosPlataformaService } from "../../generated/grpc/plataforma_catalogos_pb";
import { CultivoResponse } from "../../response/comun/CultivoResponse";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Catálogo de cultivos (gRPC-Web `CatalogosPlataformaService.ListCultivos`). Lista cacheada en memoria toda la sesión (catálogo de solo lectura); dos
 *  llamadas simultáneas comparten el mismo request. */
export class CultivoListService {
  static readonly instance = new CultivoListService();
  private constructor() {}

  private _cache: CultivoResponse[] | null = null;
  private _inflight: Promise<CultivoResponse[]> | null = null;

  /** Lista completa (el servidor ya la manda sin eliminados y ordenada). */
  async get(): Promise<CultivoResponse[]> {
    if (this._cache) return this._cache;
    if (this._inflight) return this._inflight;
    this._inflight = grpcCall(() => grpcClient(CatalogosPlataformaService).listCultivos({}))
      .then((response) => {
        this._cache = response.items.map((c) => ({
          id: c.id,
          isEliminado: false,
          nombre: c.nombre,
          isSinMonitoreo: c.isSinMonitoreo,
          isMonitoreoCafe: c.isMonitoreoCafe,
          isMonitoreoCitricos: c.isMonitoreoCitricos,
          isMonitoreoAguacateHass: c.isMonitoreoAguacateHass,
          isMonitoreoMango: c.isMonitoreoMango,
          isMonitoreoMacadamia: c.isMonitoreoMacadamia,
          isMonitoreoGuanabana: c.isMonitoreoGuanabana,
        }));
        return this._cache;
      })
      .finally(() => {
        this._inflight = null;
      });
    return this._inflight;
  }
}
